import BaseBusinessAPI from '../portal/baseBusinessAPI'

class EthnicAPI extends BaseBusinessAPI {
  controllerName = 'Ethnics';
}

export default new EthnicAPI()
